module.exports = __webpack_public_path__ + "img/music-note-01.0b17c9cb.svg";